import api from './client'

export interface ReadingRoute {
  id: string
  name: string
  description: string | null
  assigned_to: string | null
  active: boolean
  route_type: 'reading' | 'repair'
  meter_count: number
  created_at: string
  updated_at: string
}

export interface RouteMeter {
  id: string
  meter_serial: string
  subscriber_name: string
  address: string
  last_reading_value: number | null
  last_reading_date: string | null
  position: number
}

export interface RouteDevice {
  id: string
  device_key: string
  node_type: string
  label: string
  active: boolean
  position: number
}

export interface RouteDetail extends ReadingRoute {
  meters: RouteMeter[]
  devices: RouteDevice[]
}

export const readingRoutesApi = {
  list: (params?: { active_only?: boolean; route_type?: string }) =>
    api.get<ReadingRoute[]>('/routes', { params }),

  create: (body: { name: string; description?: string; assigned_to?: string; route_type?: string }) =>
    api.post<ReadingRoute>('/routes', body),

  get: (id: string) =>
    api.get<RouteDetail>(`/routes/${id}`),

  // description/assigned_to accept null (not just omission) -- PATCH
  // /routes/{id} switched to exclude_unset (meters-to-web-2026-09-21-
  // patch-clear-nullable.md): an omitted key now means "leave alone," so
  // clearing either field has to send an explicit null, not undefined.
  update: (id: string, body: { name?: string; description?: string | null; assigned_to?: string | null; active?: boolean }) =>
    api.patch<ReadingRoute>(`/routes/${id}`, body),

  addMeter: (routeId: string, meterId: string, position: number) =>
    api.post(`/routes/${routeId}/meters`, { meter_id: meterId, position }),

  removeMeter: (routeId: string, meterId: string) =>
    api.delete(`/routes/${routeId}/meters/${meterId}`),

  addDevice: (routeId: string, deviceId: string) =>
    api.post(`/routes/${routeId}/devices`, { device_id: deviceId }),

  removeDevice: (routeId: string, deviceId: string) =>
    api.delete(`/routes/${routeId}/devices/${deviceId}`),
}
